import { STATE_SELECTION_ENABLED } from 'Constants';
export const netWorthDropdown = [
    { name: "0 to $100K", id: 1 },
    { name: "$100K to $1M", id:2 },
    { name: "$1M to $5M", id: 3 },
    { name: "$5M+", id: 4 },
];
export const caseTypeArray = [
    { 
        name : "Vehicle/Truck Accident",
        id: "accident"
    },
    {
        name: "Wrongful Death",
        id: "death"
    },
    {
        name: "Catastrophic Injuries",
        id: "injury"
    },
    {
        name: "Medical Malpractice",
        id: "malpractice"
    },
    {
        name: "Sexual Assault",
        id: "assualt"
    },
    {
        name: "Product Liability",
        id: "liability"
    },
    {
        name: "Employment–related issues",
        id: "employment"
    },
    {
        name: "Non-sexual abuse/assault/neglect",
        id: "nonSexualAssault"
    },
    {
        name: "Business-related issues",
        id: "business"
    },
    {
        name: "Birth Injuries",
        id: "birthInjuries"
    },


  // ,"Premises Liability","Workplace Accidents","Family Law/ Divorce","Employment-Related Incident","Public Figure Incidents ","Emotional Distress","Civil Rights Violation","Police Misconduct","Animal Attacks","Patent Infringement"
    
]

// Same ids/backend values as caseTypeArray above (e.g. "accident") — this is
// just a different label for the same id. caseTypeArray's short professional
// names ("Vehicle/Truck Accident") are what attorneys, admins, and the case
// list use; this plain-language, first-person phrasing is what the client
// sees while picking a category during case creation (design's "Case
// details" screen). Nothing downstream needs to change: whichever options
// array a "select" field is given, that's the label shown for it, but the
// stored value is always the same id.
export const caseTypeClientOptions = [
    { name: "I was in a car, truck, or motorcycle accident", id: "accident" },
    { name: "A loved one died from someone else's negligence", id: "death" },
    { name: "I was seriously or permanently injured", id: "injury" },
    { name: "A doctor, nurse, or hospital made a mistake in my care", id: "malpractice" },
    { name: "I was sexually assaulted or abused", id: "assualt" },
    { name: "I was hurt by a defective or unsafe product", id: "liability" },
    { name: "I have a problem with my employer", id: "employment" },
    { name: "I (or someone I care about) was abused or mistreated — not sexual", id: "nonSexualAssault" },
    { name: "A dispute involving a business, contract, or partnership", id: "business" },
    { name: "My baby or I was injured during pregnancy, labor, or delivery", id: "birthInjuries" },
]
export const basicCaseInfo =
         [
            [
                {
                    label: "Email to reach you",
                    type: "input",
                    disabled: true,
                    hoverInfo: "This field is not editable; you can only use the email address that you have used to register with us.",
                    name: "contactEmail",
                    required: true,
                    error: "Your Email is a required field",
                    placeholder: "Enter your email"
                },
                
                {
                    label: "Phone number",
                    type: "number",
                    name: "contactPhone",
                    required: true,
                    length: 10,
                    regex: "^[0-9]{10}$",
                    error: "Your phone number is a required field and has to be ten digits",
                    placeholder: "Enter your phone number"
                },
                {
                    label: "How do you prefer to be contacted?", // label on Ui
                    type: "select",
                    name: "contactPref", //db field
                    options: ["Text", "Call", "OK with either"],
                    placeholder: "Do you prefer",
                    required: true,
                    error: "This is a required field."
                },
                {
                    label: "City",
                    type: "input",
                    name: "clientCity",
                    required: true,
                    error: "Your city is a required field.",
                    placeholder: "Enter your current residence city",
                },
                {
                    label: "State",
                    type: "select",
                    name: "clientState",
                    required: true,
                    error: "Your state is a required field.",
                    placeholder: "Enter your current residence State",
                },
                {
                    label: "Zipcode",
                    type: "input",
                    name: "clientZipcode",
                    required: true,
                    error: "Enter a valid 5-digit zipcode.",
                    placeholder: "Enter your current residence zipcode",
                                     
                },
                {
                    label: "Case category",
                    type: "select",
                    name: "caseType",
                    placeholder: "Choose the type of case",
                    options: caseTypeArray,
                    required: true,
                    error: "Case type is a required field."
                },
                {
                    label: "Adverse party name",
                    type: "input",
                    name: "adversePartyName",
                    required: true,
                    error: "This is a required field.",
                    placeholder: "Firstname Lastname",
                                     
                },
                {
                    label: "When did this happen ?", // label on Ui
                    type: "date",
                    name: "dateInfo", //db field
                    placeholder: "Enter zipcode of the incident location",
                    error: "Date is required.",
                    required: true
                },
                {
                    label: "What city did this incident happen in?",
                    type: "input",
                    required: true,
                    name: "caseCity",
                    placeholder: "Enter the city where this happened",
                    error: "This is a required field."
                },
                {
                    label: "What state did this incident happen in?",
                    type: "select",
                    required: true,
                    name: "caseState",
                    placeholder: "Enter the state where this happened",
                    error: "This is a required field."              
                },
                {
                    label: "What zipcode did this incident happen in?",
                    type: "input",
                    name: "caseZipcode",
                    required: true,
                    error: "Enter a valid 5-digit zipcode.",
                    placeholder: "zipcode",
                                     
                },
                {
                    label: "Additional information you would like to share with us",
                    type: "textArea",
                    name: "additionalNotes",
                    placeholder: "Additional information text box (limit 500 words) ",
                },

                // {
                //     label: "I, hereby attest that the answers, documents, if any, and video statement, if any, I have provided are true and accurate to the best of my knowledge and belief.", // label on Ui
                //     type: "checkbox",
                //     name: "attestation", //db field
                //     error: "Attesting is required to create the case",
                //     required: true
                // }
      ] ,
      [
        {
            label: "Additional information you would like to share with us",
            type: "textArea",
            name: "additionalNotes",
            placeholder: "Additional information text box (limit 500 words) ",
        },
        {
            label: "Optionally upload any supporting documents like medical records,etc.",
            type: "fileUpload",
            name: "supportingDocuments",
            placeholder: "Upload supporting documents",
        },
        {
            label: "Optionally upload any a video explaining the issues",
            type: "fileUpload",
            name: "supportingVideo",
            placeholder: "Upload supporting documents",
        },
       
    ]
]   
export const createCaseSteps = [
      { id: 1, title: "Personal information", subtitle: "Tell us about yourself and how to contact you." },
      { id: 2, title: "Case details", subtitle: "Provide details about your case." },
      { id: 3, title: "Additional information", subtitle: "A bit more context about your case and the other side." },
      { id: 4, title: "Severity rate", subtitle: "Help us understand how serious this is — this drives your case's priority." },
      { id: 5, title: "Review & Submit", subtitle: "Review your information and submit your case." }
    ];
export const formElements = [
  {
    step: 1,

    sections: [
      {

        columns: 1,
        fields: [
          {
              type: "anonymousCheckbox",
              name: "annonymous",
              label: "Post Case Anonymously",
          }
        ]
      },
      {
        title: "Personal Information",

        columns: 2,

        fields: [
          
          {
            label: "First Name",
            type: "input",
            name: "firstName",
            hideWhenAnonymous: true,
            doNotShow: true,
            required: true,
            error: "Your first name is a required field",
            placeholder: "Enter your first name"
          },
          {
            label: "Last Name",
            type: "input",
            doNotShow: true,
            hideWhenAnonymous: true,
            name: "lastName",
            required: true,
            error: "Your last name is a required field",
            placeholder: "Enter your last name"
          }
        ]
      },

      {
        title: "Contact Information",

        columns: 1,

        fields: [
          {
            label: "Phone number",
            type: "number",
            name: "contactPhone",
            required: true,
            length: 10,
            regex: "^[0-9]{10}$",
            error:
              "Your phone number is a required field and has to be ten digits",
            placeholder: "Enter your phone number"
          },
          {
            label: "How do you prefer to be contacted?",
            type: "select",
            name: "contactPref",
            options: ["Text", "Call", "OK with either"],
            placeholder: "Do you prefer",
            required: true,
            error: "This is a required field."
          }
        ]
      },

      {
        title: "Location",

        columns: 3,

        fields: [
          {
            label: "City",
            type: "input",
            name: "clientCity",
            required: true,
            error: "Your city is a required field.",
            placeholder: "Enter your current residence city"
          },
          {
            label: "State",
            type: "select",
            name: "clientState",
            required: true,
            error: "Your state is a required field.",
            placeholder: "Enter your current residence State"
          },
          {
            label: "Zipcode",
            type: "input",
            name: "clientZipcode",
            required: true,
            error: "Enter a valid 5-digit zipcode.",
            placeholder: "Enter your current residence zipcode"
          }
        ]
      }
    ]
  },

  {
    step: 2,

    sections: [
      {
        title: "",

        columns: 1,

        fields: [
          {
            label: "What happened?",
            type: "select",
            name: "caseType",
            placeholder: "Choose the type of case",
            options: caseTypeClientOptions,
            required: true,
            error: "Case type is a required field."
          },
        ]
      },
      {
        title: "",

        columns: 2,

        fields: [
          {
            label: "Who is this case against?",
            type: "input",
            name: "adversePartyName",
            required: true,
            error: "This is a required field.",
            placeholder: "e.g. John Smith or ABC Company"
          },

          {
            label: "When did this happen?",
            type: "date",
            name: "dateInfo",
            required: true,
            error: "Date is required."
          }
        ]
      },
      {
        title: "",

        columns: 1,

        fields: [
          {
            type: "sameLocationCheckbox",
            name: "caseLocationSame",
            label: "This happened at the same location I'm located",
            note: "Uncheck to enter a different city, state, or zipcode",
            cityField: {
              label: "City",
              type: "input",
              required: true,
              name: "caseCity",
              placeholder: "Enter the city where this happened",
              error: "This is a required field."
            },
            stateField: {
              label: "State",
              type: "select",
              required: true,
              name: "caseState",
              placeholder: "Enter the state where this happened",
              error: "This is a required field."
            },
            zipField: {
              label: "Zipcode",
              type: "input",
              name: "caseZipcode",
              required: true,
              error: "Enter a valid 5-digit zipcode.",
              placeholder: "zipcode"
            }
          }
        ]
      },
      {
        title: "",

        columns: 1,

        fields: [
          {
            label: "Is this case a seriously urgent matter?",
            type: "select",
            name: "sos",
            placeholder: "sos",
            options: [{name: "Yes", id: "yes"}, {name: "No", id: "no"}],
            required: true,
            error: "This is a required field."
          },
          {
            label: "Are you currently represented by an attorney ?",
            type: "select",
            name: "attAvailable",
            required: true,
            placeholder: "Choose an option",
            error: "This is a required field.",
            options: [{name: "Yes", id: "yes"}, {name: "No", id: "no"}]
          },
        ]
      },
      {
        title: "",

        columns: 1,

        fields: [
          {
            label: "Anything else you'd like to share?",
            type: "textArea",
            name: "additionalNotes",
            placeholder: "Optional"
          }
        ]
      }
    ]
  },
  {
    step : 3,
    // Design's "Additional information" step (section12a) asks exactly
    // these 3 questions. isClassAction / adversePartyNetWorth /
    // adversePartyPublicCompany aren't part of the design anymore — they're
    // still required by the backend (createCaseSchema.js) and read by
    // attorney-side filtering/valuation, so CreateFormLanding.jsx derives
    // them from isPostedBySelf/defendant/isEntity at submit time instead of
    // asking for them here.
    sections: [
      {
        title: "",
        columns: 1,
        fields : [
            {
            label: "Is this happening to you, or are you helping someone else?",
            type: "select",
            name: "isPostedBySelf",
            required: true,
            error: "This is a required field.",
            placeholder: "Choose an option",
            options: [
              {name: "It's happening to me", id: "yes"},
              {name: "I'm helping a family member or friend", id: "no"}
            ]
          },

          {
            label: "Do you know others in the same situation, against the same person or company?",
            type: "select",
            name: "defendant",
            required: true,
            error: "This is a required field.",
            placeholder: "Choose an option",
            options: [
              {name: "Just me", id: "no"}, {name: "Yes, I know of others", id: "yes"}]
          },

          // Only shown (see AdditionalInfoFields.jsx) when defendant === "yes" -
          // these are the class-action triage signals: whether the harm traces
          // to something shared (commonality) rather than a raw headcount, and
          // whether an arbitration/class-waiver clause likely rules a class
          // action out entirely. Required only while they're actually visible
          // (requiredIf, honored by isFormValid/onBlurValidate in
          // CreateFormLanding.jsx) - not required at all when defendant is
          // "no", since AdditionalInfoFields.jsx never renders them then.
          {
            label: "Did this happen because of a company-wide policy, standard contract term, or product/service defect — rather than something specific to your situation?",
            type: "select",
            name: "classActionCommonCause",
            placeholder: "Choose an option",
            requiredIf: { field: "defendant", value: "yes" },
            error: "This is a required field.",
            options: [
              {name: "Yes, a shared policy or defect", id: "yes"},
              {name: "No, mine was different", id: "no"},
              {name: "Not sure", id: "unsure"},
            ]
          },
          {
            label: "Did you sign an agreement with this company (terms of service, employment contract, etc.) that included an arbitration clause or class action waiver?",
            type: "select",
            name: "arbitrationClause",
            placeholder: "Choose an option",
            requiredIf: { field: "defendant", value: "yes" },
            error: "This is a required field.",
            options: [
              {name: "Yes", id: "yes"},
              {name: "No", id: "no"},
              {name: "Not sure", id: "unsure"},
            ]
          },

          {
            label: "Is this against a company or an individual?",
            type: "select",
            required: true,
            name: "isEntity",
            placeholder: "Choose an option",
            error: "This is a required field.",
            options: [
              {
                name: "Individual",
                id: "no"
              },
              {
                name: "Company",
                id: "yes"
              }
            ]
          },
        ]
      },
    ],
  },
  {
    step: 4,
    sections: [
        {
            title: "Physical injury",
            columns: 1,
            fields: [
                {
                    label: "How would you describe your physical injuries?",
                    type: "select",
                    name: "injuriesSeverity",
                    required: true,
                    error: "Please choose the option that best describes your injuries.",
                    options: [
                        { id: "minor", name: "Minor (cuts, bruises, sprains)" },
                        { id: "moderate", name: "Moderate (broken bone, or an injury needing treatment but expected to heal)" },
                        { id: "severe", name: "Severe (required surgery, significant ongoing pain, or loss of mobility)" },
                        { id: "lifeAltering", name: "Life-altering (permanent disability, disfigurement, or loss of function)" },
                    ]
                },
                {
                    label: "Were you hospitalized?",
                    type: "select",
                    name: "wasHospitalized",
                    reviewHidden: true,
                    options: [{ id: "yes", name: "Yes" }, { id: "no", name: "No" }, { id: "unsure", name: "Not sure" }]
                },
                {
                    label: "Did you require surgery?",
                    type: "select",
                    name: "requiredSurgery",
                    reviewHidden: true,
                    options: [{ id: "yes", name: "Yes" }, { id: "no", name: "No" }, { id: "unsure", name: "Not sure" }]
                },
                {
                    label: "Are you still receiving treatment?",
                    type: "select",
                    name: "stillReceivingTreatment",
                    reviewHidden: true,
                    options: [{ id: "yes", name: "Yes" }, { id: "no", name: "No" }, { id: "unsure", name: "Not sure" }]
                },
            ]
        },
        {
            title: "Economic damages",
            columns: 1,
            fields: [
                {
                    label: "Do you have medical bills related to this incident?",
                    type: "select",
                    name: "hasMedicalBills",
                    reviewHidden: true,
                    options: [{ id: "yes", name: "Yes" }, { id: "no", name: "No" }]
                },
                {
                    label: "Approximately how much?",
                    type: "select",
                    name: "medicalBillsRange",
                    required: true,
                    error: "Please choose an option — pick \"Not sure\" if you don't have an exact figure.",
                    options: [
                        { id: "under10k", name: "Less than $10k" },
                        { id: "10kTo100k", name: "$10k to $100k" },
                        { id: "100kTo500k", name: "$100k to $500k" },
                        { id: "over500k", name: "Over $500k" },
                        { id: "notSure", name: "Not sure" },
                    ]
                },
                {
                    label: "Have you missed work?",
                    type: "select",
                    name: "hasMissedWork",
                    reviewHidden: true,
                    options: [{ id: "yes", name: "Yes" }, { id: "no", name: "No" }]
                },
                {
                    label: "About how many days?",
                    type: "select",
                    name: "missedWorkDays",
                    reviewHidden: true,
                    options: [
                        { id: "1To5", name: "1–5 days" },
                        { id: "6To30", name: "6–30 days" },
                        { id: "overMonth", name: "Over a month" },
                        { id: "unableToWork", name: "Unable to work" },
                        { id: "notSure", name: "Not sure" },
                    ]
                },
                {
                    label: "Do you expect ongoing medical costs?",
                    type: "select",
                    name: "expectOngoingMedicalCosts",
                    reviewHidden: true,
                    options: [{ id: "yes", name: "Yes" }, { id: "no", name: "No" }, { id: "unsure", name: "Not sure" }]
                },
                {
                    label: "Did you suffer property damage?",
                    type: "select",
                    name: "hadPropertyDamage",
                    reviewHidden: true,
                    options: [{ id: "yes", name: "Yes" }, { id: "no", name: "No" }]
                },
            ]
        },
        {
            title: "Non-economic impact",
            columns: 1,
            fields: [
                {
                    label: "How has this affected your day-to-day life?",
                    type: "select",
                    name: "dayToDayImpact",
                    required: true,
                    error: "Please choose the option that best describes the impact on your day-to-day life.",
                    options: [
                        { id: "minimal", name: "Minimal — mostly recovered" },
                        { id: "some", name: "Some impact — managing daily activities" },
                        { id: "significant", name: "Significant — hard to work, sleep, or function" },
                        { id: "severe", name: "Severe — unable to work or care for myself" },
                    ]
                },
                {
                    label: "Which of these apply? (select all)",
                    type: "checkboxGroup",
                    name: "nonEconomicFactors",
                    reviewHidden: true,
                    options: [
                        { id: "sleep", name: "Trouble sleeping" },
                        { id: "stress", name: "Stress or emotional strain" },
                        { id: "activities", name: "Can't do activities I used to" },
                        { id: "relationships", name: "Strain on work or relationships" },
                    ]
                },
            ]
        },
        {
            title: "Evidence",
            columns: 1,
            fields: [
                {
                    label: "What evidence do you have? Select all that apply.",
                    type: "checkboxGroup",
                    name: "evidenceTypes",
                    required: true,
                    error: "Please select at least one type of evidence.",
                    options: [
                        { id: "medicalRecords", name: "Medical records" },
                        { id: "policeReport", name: "Police report" },
                        { id: "photosVideos", name: "Photos or videos" },
                        { id: "witnessContacts", name: "Witness contacts" },
                        { id: "textsEmails", name: "Texts or emails" },
                        { id: "payStubs", name: "Pay stubs" },
                    ]
                },
                {
                    label: "Anything else about your evidence?",
                    type: "textArea",
                    name: "proofList",
                    placeholder: "Optional",
                },
            ]
        }
    ]
  }
];

// Field -> { step, subStep } locator. Given a field's `name` (as used in
// formValues / the backend's validation `errors` map), walks formElements
// the same way CreateCaseForm.jsx already does to pick a step's fields -
// including step 4's 4 severity sub-steps and the cityField/stateField/
// zipField groups nested under a sameLocationCheckbox field - and returns
// where that field actually lives, or null if it isn't part of the wizard's
// own fields. Used to jump the wizard to (and highlight) whichever step a
// backend validation error points at, instead of leaving it as just a
// generic message on the Review & Submit step.
const SEVERITY_STEP_FOR_LOOKUP = 4;
export function locateField(name) {
  for (const element of formElements) {
    const sections = element.sections || [];
    for (let i = 0; i < sections.length; i++) {
      const fields = sections[i].fields || [];
      for (const f of fields) {
        if (f.name === name) {
          return element.step === SEVERITY_STEP_FOR_LOOKUP
            ? { step: element.step, subStep: i + 1 }
            : { step: element.step };
        }
        for (const key of ["cityField", "stateField", "zipField"]) {
          if (f[key]?.name === name) {
            return element.step === SEVERITY_STEP_FOR_LOOKUP
              ? { step: element.step, subStep: i + 1 }
              : { step: element.step };
          }
        }
      }
    }
  }
  return null;
}

export const scaleOneToTenQuestions = [
    {
        title : "Rate the severity of your physical injuries on a scale of 1 (least) to 10 (most).",
        objName: "injuriesRate",
        information: "severity of your physical injuries "
    },
    {
        title: "Rate the amount of economic damages on a scale of 1 (least) to 10 (most).",
        objName: "economicDamagesRate",
        example: "e.g., medical bills, lost wages, future medical costs, property damage, etc.",
        information: "amount of economic damages"

    },
    {
        title: "Rate the amount of non-economic damages on a scale of 1 (least) to 10 (most).",
        objName: "nonEconomicDamagesRate",
        example: "e.g., pain and suffering, emotional distress, loss of quality of life or ability to work, etc.",
        information: "amount of non-economic damages "
    },
    {
        title: "Rate the amount of proof you have to support your case on a scale of 1 (least) to 10 (most).",
        objName: "proofRate",
        example: "e.g., medical records, police reports, witness statements, etc.",
        information: "amount of proof you have"

    },
    {
      type: "textArea",
       title: "Describe the proof you have to support your case (e.g., medical records, police reports, witness statements, etc.)",
       objName: "proofList",
       example: "e.g., medical records, police reports, witness statements, etc.",
        information: "proof details"
    }
];
export const caseTypeCommonFields = 
    [
        {
            title: "Optional Adverse Party Questions",
            info: "",
            fields : [
                {
                    label: "What is the location of where the incident happened (a residence, a building, an office, a street, etc.)?  Please be as specific as possible.", // label on Ui
                    type: "input",
                    name: "incidentLocation", //db field
                    placeholder: "what is the location of the incident ?",
                },
                {
                    label: "Who owned or leased this location at the time of the incident?", // label on Ui
                    type: "input",
                    name: "ownerOfLocation", //db field
                    placeholder: "Who owned or leased this location at the time of the incident?",
                },
                {
                    label: "What is the adverse party's occupation?",
                    type: "input",
                    name: "adversePartyOccupation",
                    placeholder: "adverse party's occupation",
                },
                {
                    label: "Is the adverse party well-known or a public figure?  (yes, no, I don't know)",
                    type: "select",
                    name: "adversePartyStatus",
                    placeholder: "Adverse party status",
                    options: ["yes", "no", "I don't know"]
                },
                {
                    label: "What is the net worth of the adverse party?",
                    type: "input",
                    name: "netWorthAdverseParty",
                    placeholder: "What is the net worth of the adverse party?",
                },
               
                {
                    label: "Does the adverse party have any liability insurance?  (yes, no, I don't know)",
                    type: "select",
                    name: "liabilityInsurance",
                    placeholder: "Does the adverse party have any liability insurance?  (yes, no, I don't know)",
                    options: ["yes", "no", "I don't know"]
                },
                {
                    label: "Where does the adverse party live?  Please be as specific as possible.",
                    type: "input",
                    name: "adversePartyLive",
                    placeholder: "· Where does the adverse party live?  Please be as specific as possible. ",
                },
                {
                    label: "Does the adverse party own any real estate? If yes, where is the adverse party's real estate located? (yes, no, I don't know)",
                    type: "select",
                    name: "realEstateLocation",
                    placeholder: "Adverse party location",
                    options: ["yes", "no", "I don't know"]
                },
                {
                    label: "Does the adverse party own any businesses?    If yes, what are the businesses and where are they located? (yes, no, I don't know)",
                    type: "select",
                    name: "ownBusiness",
                    placeholder: "Adverse party status",
                    options: ["yes", "no", "I don't know"]
                },
                {
                    label: "Does the adverse party own any valuable personal property, such as jewelry, cars, or collectibles?  (yes, no, I don't know)",
                    type: "select",
                    name: "adversePartyValueable",
                    placeholder: "Adverse party status",
                    options: ["yes", "no", "I don't know"]
                },
                {
                    label: "Does the adverse party own any social media accounts, websites, apps, or other digital properties such as music?  (yes, no, I don't know)",
                    type: "select",
                    name: "adversePartySocialMedia",
                    placeholder: "Adverse party status",
                    options: ["yes", "no", "I don't know"]
                },
                {
                    label: "Does the adverse party own any patents or trademarks?  (yes, no, I don't know)",
                    type: "select",
                    name: "adversePartyPatent",
                    placeholder: "Adverse party patent",
                    options: ["yes", "no", "I don't know"]
                },
                {
                    label: "Does the adverse party have any agent or manager?  If yes, what is their name, location, and contact information? (yes, no, I don't know)",
                    type: "select",
                    name: "adversePartyAgent",
                    placeholder: "Adverse party agent",
                    options: ["yes", "no", "I don't know"]
                },
                {
                    label: "Has the adverse party ever been in litigation?    If yes, what type of case? (yes, no, I don't know)",
                    type: "select",
                    name: "adversePartyLitigation",
                    placeholder: "Adverse party litigation",
                    options: ["yes", "no", "I don't know"]
                },
            ]
        },
        {
            title: "Optional Adverse Party Employer Questions",
            info: "",
            fields : [
                {
                    label: "Who is the adverse party's employer?", // label on Ui
                    type: "input",
                    name: "adversePartyEmployer", //db field
                    placeholder: "Who is the adverse party's employer?",
                },
                {
                    label: "What is the adverse party's employer's valuation (estimated worth of the business)?", // label on Ui
                    type: "input",
                    name: "adversePartyValuation", //db field
                    placeholder: "What is the adverse party's employer's valuation (estimated worth of the business)?",
                },
                {
                    label: "What is the annual revenue of the adverse party's employer?",
                    type: "input",
                    name: "adversePartyAnnualRevenue",
                    placeholder: "What is the annual revenue of the adverse party's employer?",
                },
                {
                    label: "Did the incident happen while the adverse party was working on the job?  (yes, no, I don't know)",
                    type: "select",
                    name: "adversePartyJobWorking",
                    placeholder: "Was adverse party working",
                    options: ["yes", "no", "I don't know"]
                },
                {
                    label: "Where is the adverse party's employer located?",
                    type: "input",
                    name: "adversePartyEmployerLocated",
                    placeholder: "Where is the adverse party's employer located?",
                },
                {
                    label: "Does the adverse party's employer have liability insurance?  (yes, no, I don't know)",
                    type: "select",
                    name: "adversePartyLiabilityInsurance",
                    options: ["yes", "no", "I don't know"],
                    placeholder: "Does the adverse party's employer have liability insurance?  (yes, no, I don't know)",
                },
                {
                    label: "Has the adverse party's employer ever been in litigation for a similar type of case? (yes, no, I don't know)",
                    type: "select",
                    name: "adversePartySimilarCase",
                    options: ["yes", "no", "I don't know"],
                    placeholder: "· Has the adverse party's employer ever been in litigation for a similar type of case? (yes, no, I don't know)",
                },
            ]
        },
        // {
        //     title: "Optional Records/Documentation Questions",
        //     info: "",
        //     fields : [
        //             {
        //                 label: "Do you have medical records of your suffering?  (yes or no)",
        //                 type: "fileUpload",
        //                 name: "sufferingRecords",
        //                 placeholder: "Medical records",
        //             },
        //             {
        //                 label: "Do you have additional documentation of your suffering (not uploaded here)? (yes or no)",
        //                 type: "select",
        //                 name: "sufferingAddditionalDocumentation",
        //                 placeholder: "",
        //                 options: ["yes", "no" ]
        //             },
        //     ]
        // }
    ]

// case specific fields
// export const caseTypeFields = {
//     "accident" :[
//                     {
//                         title: "Similar Situation Against Adverse Party Question:",
//                         info: "",
//                         fields : [
//                             {
//                                 label: "Do you know anyone else who had a similar situation to yours against the same adverse party? (If yes, insert first name, last name, email address)", // label on Ui
//                                 type: "select",
//                                 name: "similarSituation", //db field
//                                 options: ["yes", "no"],
//                                 placeholder: "Do you know anyone else who had a similar situation to yours against the same adverse party?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "This is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "First name", // label on Ui
//                                 type: "input",
//                                 name: "similarFirstName", //db field
//                                 placeholder: "First name of the person",
                                                 
//                             },
//                             {
//                                 label: "Last name",
//                                 type: "input",
//                                 name: "similarLastName",
//                                 placeholder: "Last name of the person",
                                                 
//                             },
//                             {
//                                 label: "Email",
//                                 type: "input",
//                                 name: "similarEmail",
//                                 placeholder: "Email of the person",
                                                 
//                             },
//                         ]    
//                     },
//                     {
//                         title: "Adverse party questions : ",
//                         info: "",
//                         fields : [
//                             {
//                                 label: "What is the name of the other driver involved in the accident?", // label on Ui
//                                 type: "input",
//                                 name: "driverName", //db field
//                                 options: ["yes", "no"],
//                                 placeholder: "Name of the other driver involved in the accident?(Firstname Lastname)",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Driver information is a required field",
//                                     ]
//                                 }] 
//                             },
                            
//                             {
//                                 label: "Do you have the other driver's contact information?", // label on Ui
//                                 type: "select",
//                                 name: "isDriverInfo", //db field
//                                 options: ["yes", "no"],
//                                 isValid: true,
//                                 required: true,
//                                 placeholder: "Do you have the other driver's contact information?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Driver information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "What is the other driver's contact information?", // label on Ui
//                                 type: "input",
//                                 name: "driverContact", //db field
//                                 placeholder: "Contact information of the other driver",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Driver contact is a required field",
//                                     ]
//                                 }]
//                             },
//                             {
//                                 label: "What is the make, model, and year of the other vehicle involved in the accident?", // label on Ui
//                                 type: "input",
//                                 name: "vehicleInfo", //db field
//                                 placeholder: "The make, model, and year of the other vehicle involved in the accident",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Vehicle information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "Why do you believe this person or entity is responsible?", // label on Ui
//                                 type: "textArea",
//                                 name: "responsible", //db field
//                                 placeholder: "Explain why do you believe that this person or entity is responsible",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "This is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "Do you have any insurance information for the responsible person or entity?", // label on Ui
//                                 type: "select",
//                                 name: "isInsurance", //db field
//                                 options: ["yes", "no"],
//                                 placeholder: "Do you have any insurance information for the responsible person or entity?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Insurance information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "Have you filed a report with the police or any other relevant authorities?", // label on Ui
//                                 type: "select",
//                                 name: "isReport", //db field
//                                 options: ["yes", "no"],
//                                 placeholder: "Have you filed a report with the police or any other relevant authorities?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Report information is a required field",
//                                     ]
//                                 }] 
//                             },
//                         ]
//                     },
//                     {
//                         title: "Questions about the accident or incident:",
//                         info: "",
//                         fields : [
//                             {
//                                 label: "Can you tell me about the accident or incident that caused your injury?" ,// label on Ui
//                                 type: "textArea",
//                                 name: "infoIncident", //db field
//                                 placeholder: "Explain about the accident or incident that caused your injury",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Injury information is a required field",
//                                     ]
//                                 }] 
//                             },
                            
//                             {
//                                 label: "Where and when did the accident or incident happen?", // label on Ui
//                                 type: "textArea",
//                                 name: "locationInfo", //db field
//                                 placeholder: "Where and when did the accident or incident happen?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Incident location information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "Who was involved in the accident or incident?", // label on Ui
//                                 type: "input",
//                                 name: "involvedAccident", //db field
//                                 placeholder: "Firstname  Lastname",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "This information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "How did the accident or incident happen?", // label on Ui
//                                 type: "textArea",
//                                 name: "accidentInfo", //db field
//                                 placeholder: "How did the accident or incident happen?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Accident information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "What were your injuries?", // label on Ui
//                                 type: "textArea",
//                                 name: "injuries", //db field
//                                 placeholder: "What are your injuries?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Injuries is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "Have you received medical treatment for your injuries?", // label on Ui
//                                 type: "select",
//                                 name: "isTreatmentReceived", //db field
//                                 options: ["yes", "no"],
//                                 placeholder: "Have you received medical treatment for your injuries?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Treatment information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "What is your doctor's prognosis?", // label on Ui
//                                 type: "textArea",
//                                 name: "doctorPrognosis", //db field
//                                 placeholder: "Your doctor's prognosis",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Doctor prognosis information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "Do you have any medical records or bills related to your injuries?",
//                                 type: "select",
//                                 name: "isRecords", //db field
//                                 options: ["yes", "no"],
//                                 placeholder: "Do you have any medical records or bills related to your injuries?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Records information is a required field",
//                                     ]
//                                 }] 
//                             },
//                         ]
//                     },
//                     {
//                         title: "Questions about your damages:",
//                         info: "",
//                         fields : [
//                             {
//                                 label: "How have your injuries affected your life?",
//                                 type: "textArea",
//                                 name: "injuryInfo", //db field
//                                 placeholder: "Explain how your injuries affected your life",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Injury information is a required field",
//                                     ]
//                                 }] 
//                             },
                            
//                             {
//                                 label:"Have you missed work or school due to your injuries?", // label on Ui
//                                 type: "select",
//                                 name: "isMissedWork", //db field
//                                 options: ["yes", "no"],
//                                 placeholder:"Have you missed work or school due to your injuries?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "This information is a required information",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "Have you incurred any medical expenses?", // label on Ui
//                                 type: "input",
//                                 name: "expenseIncurred", //db field
//                                 placeholder: "Have you incurred any medical expenses?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Expense information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "Have you incurred any other expenses related to your injuries, such as transportation or childcare?", // label on Ui
//                                 type: "textArea",
//                                 name: "otherExpenseIncurred", //db field
//                                 placeholder: "Have you incurred any other expenses related to your injuries, such as transportation or childcare?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "This information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "Are you still experiencing pain or other symptoms?",
//                                 type: "select",
//                                 name: "isPain", //db field,
//                                 options: ["yes", "no"],
//                                 placeholder: "Are you still experiencing pain or other symptoms?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Injuries is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "How has your injury affected your ability to perform daily activities?", // label on Ui
//                                 type: "textArea",
//                                 name: "affectedDailyActivities", //db field
//                                 placeholder: "How has your injury affected your ability to perform daily activities?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "This information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "How has your injury affected your emotional well-being?", // label on Ui
//                                 type: "textArea",
//                                 name: "affectedEmotionalBeing", //db field
//                                 placeholder: "How has your injury affected your emotional well-being?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Doctor prognosis information is a required field",
//                                     ]
//                                 }] 
//                             },
//                         ]
//                     },
//                     {
//                         title: "Financial Impact Questions",
//                         info: "",
//                         fields : [
//                             {
//                                 label: "Have you lost any wages due to your injuries?",
//                                 type: "select",
//                                 name: "isWagesLost", 
//                                 options: ["yes", "no"],
//                                 placeholder: "Have you lost any wages due to your injuries?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Wages information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "If so, can you provide documentation of your lost wages?",
//                                 type: "fileUpload",
//                                 name: "wageDoc",
//                                 placeholder: "If so, can you provide documentation of your lost wages?",
//                             },
//                             {
                                
//                                 label: "Have you incurred any medical expenses related to your injuries?",
//                                 type: "select",
//                                 name: "isExpenseForInjuries", 
//                                 options: ["yes", "no"],
//                                 placeholder: "Have you incurred any medical expenses related to your injuries?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "Injury information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "If so, can you provide copies of your medical bills?",
//                                 type: "fileUpload",
//                                 name: "medicalBillDoc",
//                                 placeholder: "If so, can you provide copies of your medical bills?",
//                             },
//                             {
                                
//                                 label: "Have you had to make any modifications to your home or vehicle due to your injuries?",
//                                 type: "select",
//                                 name: "isModifications", 
//                                 options: ["yes", "no"],
//                                 placeholder: "Have you had to make any modifications to your home or vehicle due to your injuries?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "This information is a required field",
//                                     ]
//                                 }] 
//                             },
//                             {
//                                 label: "If so, can you provide documentation of the costs of these modifications?",
//                                 type: "fileUpload",
//                                 name: "modificationsDoc",
//                                 placeholder: "If so, can you provide documentation of the costs of these modifications?",
//                             },
//                         ] 
//                     },
//                     {
//                         title: "Accident Details",
//                         info: "",
//                         fields : [
//                         {
//                             label: "Where did the accident occur?", // label on Ui
//                             type: "input",
//                             name: "incidentLocation", //db field
//                             placeholder: "Where did the accident occur?",
//                             "validationType": "string",
//                             "validations": [{
//                                 "type": "required",
//                                 "params": [
//                                     "This information is a required field",
//                                 ]
//                             }] 
//                         },
//                         {
//                             label: "When did the accident occur?", // label on Ui
//                             type: "input",
//                             name: "incidentTime", //db field
//                             placeholder: "When did the accident occur?",
//                             "validationType": "string",
//                             "validations": [{
//                                 "type": "required",
//                                 "params": [
//                                     "This information is a required field",
//                                 ]
//                             }] 
//                         },
//                         {
//                             label: "What were the weather conditions at the time of the accident?", // label on Ui
//                             type: "input",
//                             name: "incidentWeather", //db field
//                             placeholder: "What were the weather conditions at the time of the accident?",
//                             "validationType": "string",
//                             "validations": [{
//                                 "type": "required",
//                                 "params": [
//                                     "This information is a required field",
//                                 ]
//                             }] 
//                         },
//                         {
                                
//                             label: "Was the accident reported to the police?",
//                             type: "select",
//                             name: "isReportedToPolice", 
//                             options: ["yes", "no"],
//                             placeholder: "Was the accident reported to the police?",
//                             "validationType": "string",
//                             "validations": [{
//                                 "type": "required",
//                                 "params": [
//                                     "This information is a required field",
//                                 ]
//                             }] 
//                         },
//                         {
//                             label: "Do you have a police report or accident report?", // label on Ui
//                             type: "fileUpload",
//                             name: "policeReportDoc", //db field
//                         },
//                     ]
//                     },
//                     {
//                        title: "Inquiry Questions",
//                        info: "",
//                        fields:  [
//                         {
//                             "label": "What injuries did you sustain in the accident?",
//                             "type": "input",
//                             "name": "injuriesSustained",
//                             "placeholder": "What injuries did you sustain in the accident?",
//                             "validationType": "string",
//                             "validations": [
//                                 {
//                                     "type": "required",
//                                     "params": [
//                                         "This information is a required field"
//                                     ]
//                                 }
//                             ]
//                         },
//                         {
//                             "label": "Have you sought medical attention for your injuries?",
//                             "type": "select",
//                             "name": "isMedicalAttentionSought",
//                             "options": [
//                                 "yes",
//                                 "no"
//                             ],
//                             "placeholder": "Have you sought medical attention for your injuries?",
//                             "validationType": "string",
//                             "validations": [
//                                 {
//                                     "type": "required",
//                                     "params": [
//                                         "This information is a required field"
//                                     ]
//                                 }
//                             ]
//                         },
//                         {
//                             "label": "Do you have any medical records or documentation of your injuries?",
//                             "type": "fileUpload",
//                             "name": "medicalRecordsDoc",
//                             "placeholder": "Do you have any medical records or documentation of your injuries?",
                            
//                         },
//                         {
//                             "label": "How have your injuries impacted your daily life?",
//                             "type": "input",
//                             "name": "",
//                             "placeholder": "How have your injuries impacted your daily life?",
//                             "validationType": "string",
//                             "validations": [
//                                 {
//                                     "type": "required",
//                                     "params": [
//                                         "This information is a required field"
//                                     ]
//                                 }
//                             ]
//                         },
//                         {
//                             "label": "When did you discover your injuries?",
//                             "type": "input",
//                             "name": "",
//                             "placeholder": "When did you discover your injuries?",
//                             "validationType": "string",
//                             "validations": [
//                                 {
//                                     "type": "required",
//                                     "params": [
//                                         "This information is a required field"
//                                     ]
//                                 }
//                             ]
//                         }
//                     ]
//                     },
//                     {
//                         title: "Insurance Questions",
//                         info: "",
//                         fields : [
//                             {
                                
//                                 label: "Do you have car insurance?",
//                                 type: "select",
//                                 name: "isCarInsurance", 
//                                 options: ["yes", "no"],
//                                 placeholder: "Do you have car insurance?",
//                                 "validationType": "string",
//                                 "validations": [{
//                                     "type": "required",
//                                     "params": [
//                                         "This information is a required field",
//                                     ]
//                                 }] 
//                             },
//                         {
//                             label: "Do you have any other relevant insurance policies (health, life, etc.)?", // label on Ui
//                             type: "input",
//                             name: "relevantInsurancePolicy", //db field
//                             placeholder: "Do you have any other relevant insurance policies (health, life, etc.)?",
//                             "validationType": "string",
//                             "validations": [{
//                                 "type": "required",
//                                 "params": [
//                                     "This information is a required field",
//                                 ]
//                             }] 
//                         },
//                         {
//                             label: "What is your insurance coverage?", // label on Ui
//                             type: "input",
//                             name: "insuranceCoverage", //db field
//                             placeholder: "What is your insurance coverage?",
//                             "validationType": "string",
//                             "validations": [{
//                                 "type": "required",
//                                 "params": [
//                                     "This information is a required field",
//                                 ]
//                             }] 
//                         },
//                         {
//                             label: "Have you filed a claim with your insurance company?", // label on Ui
//                             type: "select",
//                             name: "isClaimFiled", //db field
//                             options: ["yes", "no"],
//                             placeholder: "Have you filed a claim with your insurance company?",
//                             "validationType": "string",
//                             "validations": [{
//                                 "type": "required",
//                                 "params": [
//                                     "This information is a required field",
//                                 ]
//                             }] 
//                         },
//                     ]
//                     },
//                     {
//                         "title" : "Insurance coverage Questions",
//                         "info" : "",
//                         fields: [
//                             {
//                                 "label": "What is your policy deductible for car accidents?",
//                                 "type": "input",
//                                 "name": "policyDeductible",
//                                 "placeholder": "What is your policy deductible for car accidents?",
//                                 "validationType": "string",
//                                 "validations": [
//                                     {
//                                         "type": "required",
//                                         "params": [
//                                             "This information is a required field"
//                                         ]
//                                     }
//                                 ]
//                             },
//                             {
//                                 "label": "Does your insurance policy cover personal injury protection (PIP)?",
//                                 "type": "select",
//                                 "name": "isPolicyCoversPIP",
//                                 "options": [
//                                     "yes",
//                                     "no"
//                                 ],
//                                 "placeholder": "Does your insurance policy cover personal injury protection (PIP)?",
//                                 "validationType": "string",
//                                 "validations": [
//                                     {
//                                         "type": "required",
//                                         "params": [
//                                             "This information is a required field"
//                                         ]
//                                     }
//                                 ]
//                             },
//                             {
//                                 "label": "If so, what is your PIP coverage limit?",
//                                 "type": "input",
//                                 "name": "coverageLimit",
//                                 "placeholder": "If so, what is your PIP coverage limit?",
//                                 "validationType": "string",
//                                 "validations": [
//                                     {
//                                         "type": "required",
//                                         "params": [
//                                             "This information is a required field"
//                                         ]
//                                     }
//                                 ]
//                             },
//                             {
//                                 "label": "Does your insurance policy cover uninsured/underinsured motorist coverage (UM/UIM)?",
//                                 "type": "select",
//                                 "name": "isPolicyCoversUM",
//                                 "options": [
//                                     "yes",
//                                     "no"
//                                 ],
//                                 "placeholder": "Does your insurance policy cover uninsured/underinsured motorist coverage (UM/UIM)?",
//                                 "validationType": "string",
//                                 "validations": [
//                                     {
//                                         "type": "required",
//                                         "params": [
//                                             "This information is a required field"
//                                         ]
//                                     }
//                                 ]
//                             },
//                             {
//                                 "label": "If so, what are your UM/UIM coverage limits?",
//                                 "type": "input",
//                                 "name": "coverageLimitUM",
                                
//                                 "placeholder": "If so, what are your UM/UIM coverage limits?",
//                                 "validationType": "string",
//                                 "validations": [
//                                     {
//                                         "type": "required",
//                                         "params": [
//                                             "This information is a required field"
//                                         ]
//                                     }
//                                 ]
//                             }
//                         ]
//                     },
//                     {
//                         title: "Additional Questions",
//                         info: "",
//                         fields : [
//                             {
//                                 "label": "Have you consulted with any other attorneys about your case?",
//                                 "type": "select",
//                                 "name": "isAttorneyConsulted",
//                                 "options": [
//                                     "yes",
//                                     "no"
//                                 ],
//                                 "placeholder": "Have you consulted with any other attorneys about your case?",
//                                 "validationType": "string",
//                                 "validations": [
//                                     {
//                                         "type": "required",
//                                         "params": [
//                                             "This information is a required field"
//                                         ]
//                                     }
//                                 ]
//                             },
//                             {
//                                 "label": "Are you aware of any deadlines for filing a personal injury lawsuit?",
//                                 "type": "select",
//                                 "name": "isDeadlineAware",
//                                 "options": [
//                                     "yes",
//                                     "no"
//                                 ],
//                                 "placeholder": "Are you aware of any deadlines for filing a personal injury lawsuit?",
//                                 "validationType": "string",
//                                 "validations": [
//                                     {
//                                         "type": "required",
//                                         "params": [
//                                             "This information is a required field"
//                                         ]
//                                     }
//                                 ]
//                             },
//                             {
//                                 "label": "Are you interested in exploring alternative dispute resolution (ADR) methods, such as mediation or arbitration?",
//                                 "type": "select",
//                                 "name": "isAlternatives",
//                                 "options": [
//                                     "yes",
//                                     "no"
//                                 ],
//                                 "placeholder": "Are you interested in exploring alternative dispute resolution (ADR) methods, such as mediation or arbitration?",
//                                 "validationType": "string",
//                                 "validations": [
//                                     {
//                                         "type": "required",
//                                         "params": [
//                                             "This information is a required field"
//                                         ]
//                                     }
//                                 ]
//                             },
//                             {
//                                 "label": "Have you ever been involved in a similar accident or incident before?",
//                                 "type": "select",
//                                 "name": "isInvolvedInSimilar",
//                                 "options": [
//                                     "yes",
//                                     "no"
//                                 ],
//                                 "placeholder": "Have you ever been involved in a similar accident or incident before?",
//                                 "validationType": "string",
//                                 "validations": [
//                                     {
//                                         "type": "required",
//                                         "params": [
//                                             "This information is a required field"
//                                         ]
//                                     }
//                                 ]
//                             },
//                             {
//                                 "label": "Do you have any witnesses who can corroborate your story?",
//                                 "type": "select",
//                                 "name": "isWitnessAvailable",
//                                 "options": [
//                                     "yes",
//                                     "no"
//                                 ],
//                                 "placeholder": "Do you have any witnesses who can corroborate your story?",
//                                 "validationType": "string",
//                                 "validations": [
//                                     {
//                                         "type": "required",
//                                         "params": [
//                                             "This information is a required field"
//                                         ]
//                                     }
//                                 ]
//                             },
//                             {
//                                 "label": "Have you already consulted with another attorney about your case?",
//                                 "type": "select",
//                                 "name": "isAnotherAttorneyConsulted",
//                                 "options": [
//                                     "yes",
//                                     "no"
//                                 ],
//                                 "placeholder": "Have you already consulted with another attorney about your case?",
//                                 "validationType": "string",
//                                 "validations": [
//                                     {
//                                         "type": "required",
//                                         "params": [
//                                             "This information is a required field"
//                                         ]
//                                     }
//                                 ]
//                             }
//                         ]
//                     },
//                     {
//                         title: "Witness Questions",
//                         info: "",
//                         fields: [
//                             {
//                                 "label": "Are there any witnesses to the accident?",
//                                 "type": "select",
//                                 "name": "isWitnessAvail",
//                                 "options": ["yes","no"],
//                                 "placeholder": "Are there any witnesses to the accident?",
//                                 "validationType": "string",
//                                 "validations": [
//                                     {
//                                         "type": "required",
//                                         "params": [
//                                             "This information is a required field"
//                                         ]
//                                     }
//                                 ]
//                             },
//                             {
//                                 "label": "If so, can you provide their contact information?",
//                                 "type": "input",
//                                 "name": "witnessContactinfo",
//                                 "options": "",
//                                 "placeholder": "If so, can you provide their contact information?",
//                                 "validationType": "string",
//                                 "validations": [
//                                     {
//                                         "type": "required",
//                                         "params": [
//                                             "This information is a required field"
//                                         ]
//                                     }
//                                 ]
//                             }
//                         ]
//                     },
//                     {
//                         title: "Anything else you’d like to provide?",
//                         info: "",
//                         fields: [{
//                             label: "", // label on Ui
//                             type: "textArea",
//                             name: "extraInformation", //db field
//                             placeholder: "Write in any extra information here"
//                         },
//                         {
//                             label: "Upload supporting documents",
//                             type: "fileUpload",
//                             name: "supportingDocuments",
//                             placeholder: "Upload supporting documents",
//                         },
//                         {
//                             label: "Upload video statement",
//                             type: "fileUpload",
//                             name: "videoUpload",
//                             placeholder: "Upload supporting video",
//                         },
//                         {
//                             label: "I, hereby attest that the answers, documents, if any, and video statement, if any, I have provided are true and accurate to the best of my knowledge and belief.", // label on Ui
//                             type: "checkbox",
//                             name: "attestation", //db field
//                         }
//                     ]
//                     },
                    
//                 ],
//     "death" : [
//         {
//         title: "Adverse Party - Death",
//         info: "",
//         fields : [
//             {
//                 label: "What entity do you believe is responsible for this wrongful death?", // label on Ui
//                 type: "input",
//                 name: "adversePartyEntity", //db field
//                 placeholder: "What entity do you believe is responsible for this wrongful death?",
//                 "validationType": "string",
//                 "validations": [{
//                     "type": "required",
//                     "params": [
//                         "adverse party is a required field",
//                     ]
//                 }] 
//             },
//         ]    
//     }
// ]
// }


// Texas-only launch (see STATE_SELECTION_ENABLED in Constants.js): take the
// state questions out of the case form. caseState / clientState are filled
// with DEFAULT_STATE on submit (CreateFormLanding.jsx).
const STATE_FIELD_NAMES = ["clientState", "caseState"];
function stripStateFields(node) {
    if (Array.isArray(node)) {
        // plain lists of fields (basicCaseInfo) - drop the state ones in place
        for (let i = node.length - 1; i >= 0; i--) {
            if (node[i] && STATE_FIELD_NAMES.includes(node[i].name)) node.splice(i, 1);
        }
        node.forEach(stripStateFields);
        return;
    }
    if (!node || typeof node !== "object") return;
    if (Array.isArray(node.fields)) {
        const before = node.fields.length;
        node.fields = node.fields.filter((f) => !(f && STATE_FIELD_NAMES.includes(f.name)));
        if (node.fields.length < before && node.columns === 3) node.columns = 2;
    }
    if (node.stateField) node.stateField = null;
    Object.values(node).forEach((v) => { if (v && typeof v === "object") stripStateFields(v); });
}
// Only the create-case form (formElements). basicCaseInfo is also used to
// *display* case details (RequiredInfo, case PDF), where showing the state is fine.
if (!STATE_SELECTION_ENABLED) {
    stripStateFields(formElements);
}
